import commonRes from '../abstract.resource';
import {readJobTitle} from '../serializers/job-title.serializer';

const mod = angular.module('app.common.resources.job-titles', [commonRes])

.factory('JobTitleResource', function ($q, AbstractResource) {
  class JobTitleResource extends AbstractResource {
    constructor() {
      super('job-titles', JobTitleResource.fromBackend, true);
    }

    /**
     * Parse a JobTitle retrieved from the backend.
     * @param {Object} o
     * @returns {JobTitle}
     */
    static fromBackend(o) {
      return readJobTitle(o).makeImmutable();
    }
  }

  return new JobTitleResource();
});

export default mod.name;



// WEBPACK FOOTER //
// ./src/app/common/resources/job-title.resource.js